// The reply inbox a client subscribes for a reply that is not one message —
// the frame grammar's reader, a discovery scatter — inside the fence the
// connection was placed with (decision 0006). Internal.
import { createInbox } from "@nats-io/nats-core";
/**
 * inboxPrefixOf reads the inbox prefix the connection was placed with.
 * nats-core keeps it on the connection's options, which the NatsConnection
 * interface does not surface; a connection without one uses the default.
 */
export function inboxPrefixOf(nc) {
    if ("options" in nc &&
        typeof nc.options === "object" &&
        nc.options !== null &&
        "inboxPrefix" in nc.options) {
        const prefix = nc.options.inboxPrefix;
        if (typeof prefix === "string" && prefix !== "") {
            return prefix;
        }
    }
    return undefined;
}
/** newInbox mints a reply inbox inside the connection's fence: `<prefix>.<nuid>`. */
export function newInbox(nc) {
    return createInbox(inboxPrefixOf(nc));
}
//# sourceMappingURL=inbox.js.map